import { useState, useEffect } from "react";
import Outreachleader from "components/outreachleader/Outreachleader";
import Outreachstaff from "components/outreachstaff/Outreachstaff";
import ReferralCoordinator from "components/common/referralcoordinator/referralcoordinator";

const UserList = () => {
  const [status, setStatus] = useState("outreach_leader");
  const [users, setUsers] = useState([]);

  const handleSetReferralFilter = (selectedValue) => {
    setStatus(selectedValue);
  };
  const renderComponent = () => {
    if (status === "outreach_staff") {
      return (
        <Outreachstaff
          users={users}
          onStatusChange={handleSetReferralFilter}
          status={status}
        />
      );
    } else if (status === "referralcoordinator") {
      return (
        <ReferralCoordinator
          users={users}
          onStatusChange={handleSetReferralFilter}
          status={status}
        />
      );
    }
    return (
      <Outreachleader
        users={users}
        onStatusChange={handleSetReferralFilter}
        status={status}
      />
    );
  };

  return (
    <>
      <h1 className="heading-h5">Users</h1>
      {renderComponent()}
    </>
  );
};

export default UserList;
